import React, { Fragment } from 'react';
import {
	Button,
	Dropdown,
	Form,
	Modal,
	Table,
	Segment,
	Dimmer,
	Loader,
	Image,
	Accordion,
	Icon
} from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import Rx from 'stores/Rx';
import * as styles from './styles.js';
import { observable, IObservableArray, toJS } from 'mobx';
import type { AssignableUser } from 'stores/Account';
import MessageBox from 'components/MessageBox';
import MsgStore from 'stores/MsgStore';
import UiShared from 'stores/UiShared';
import Auth from 'stores/Auth';
import API from 'api';
import _ from 'lodash';
import eyeMap from 'data/eyeMap';

@inject(rootStore => ({
	auth: rootStore.auth,
	uiShared: rootStore.uiShared
}))
@observer
export default class BulkApproval extends React.Component {
	props: {
		isOpen: boolean,
		onRequestReload: () => {},
		onRequestClose: () => {},
		auth?: Auth,
		uiShared: UiShared,
		ids: []
	};

	static defaultProps = {
		isOpen: false
	};

	@observable rx: Rx = new Rx();
	msgStore: MsgStore = new MsgStore();

	@observable
	active = {
		name: 'createAuthority',
		json: true,
		inputJsonValue: '',
		responseData: ''
	};
	@observable responseData = '';
	@observable assessmentDetailsText = '';
	@observable showDebug: boolean = false;
	@observable showResultDlg: boolean = false;
	@observable answersSubmitted: boolean = false;
	@observable isConfirmed: boolean = false;
	@observable debugIdx: number = 1;
	@observable showLoader: boolean = true;
	@observable saving: boolean = false;
	@observable inputJsonValue: string = '';
	@observable restrictionCode: number = 0;
	@observable expandedRows = [];
	@observable requiredQuestions = [];
	@observable responses: IObservableArray<object> = [];
	@observable approvedCount: number = 0;
	@observable rejectedCount: number = 0;

	componentDidUpdate = async prevProps => {
		const { uiShared, onRequestReload } = this.props;
		try {
			if (this.props.isOpen && !prevProps.isOpen) {
				this.approvedCount = 0;
				this.rejectedCount = 0;
				this.msgStore.clear();
				this.showResultDlg = false;
				uiShared.showSpinner('Submitting...');
				await this.processBulk();
				uiShared.hideModal();
				this.showResultDlg = true;
				await onRequestReload();
			}
		} catch (e) {
			this.showDebug = true;
			this.msgStore.setError(e);
		}
	};

	processBulk = async () => {
		const ids = this.props.ids;
		try {
			const response = await Rx.processBulk(ids);
			const result = toJS(response);
			this.approvedCount = result.approvedCount;
			this.rejectedCount = result.rejectedCount;
		} catch (err) {
			console.log('Error:', err);
			this.msgStore.setError(err);
		}
	};

	renderResult = () => {
		const { approvedCount, rejectedCount } = this;
		return (
			<div className={styles.resultReasonCnt}>
				<h4>{`${approvedCount} scripts Approved`}</h4>
				<h4>{`${rejectedCount} scripts Rejected`}</h4>
			</div>
		);
	};

	render() {
		const { onRequestClose } = this.props;
		const { renderResult } = this;

		return (
			<Fragment>
				<Modal
					size="mini"
					open={this.showResultDlg}
					onClose={() => {
						this.showResultDlg = false;
						onRequestClose();
					}}
					className={styles.modalConfirmation}
					closeIcon={true}
				>
					<Modal.Content>
						<p>{this.showResultDlg && renderResult()}</p>
						<div className={styles.resultRowBtn}>
							<Button
								onClick={() => {
									this.showResultDlg = false;
									onRequestClose();
								}}
							>
								OK
							</Button>
						</div>
					</Modal.Content>
				</Modal>
			</Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Script/BulkApproval.js